import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vex-otp-modal-component',
  templateUrl: './otp-modal-component.component.html',
  styleUrls: ['./otp-modal-component.component.scss']
})
export class OtpModalComponentComponent implements OnInit {

  otp: string = '';
  constructor(private dialogRef: MatDialogRef<OtpModalComponentComponent>) {}

  ngOnInit(): void {
  }
 

  submitOtp() {
    if (this.otp.trim()) {
      this.dialogRef.close(this.otp); // on retourne la valeur OTP au parent
    }
  }

  close() {
    this.dialogRef.close();
  }






}
